var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.687 9.03175L15.3162 5.40249C15.7881 4.96697 15.7881 4.24112 15.3162 3.80561L14.5178 3.00717C14.0823 2.53537 13.3564 2.53537 12.9209 3.00717L9.29167 6.63644L5.62612 3.00717C5.19061 2.53537 4.46476 2.53537 4.02924 3.00717L3.23081 3.80561C2.759 4.24112 2.759 4.96697 3.23081 5.40249L6.86007 9.03175L3.23081 12.6973C2.759 13.1328 2.759 13.8587 3.23081 14.2942L4.02924 15.0926C4.46476 15.5644 5.19061 15.5644 5.62612 15.0926L9.29167 11.4634L12.9209 15.0926C13.3564 15.5644 14.0823 15.5644 14.5178 15.0926L15.3162 14.2942C15.7881 13.8587 15.7881 13.1328 15.3162 12.6973L11.687 9.03175Z",
    fill: "#333333"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.670e0a6398172704e6bd92fbd57b5a25.svg";
export { ForwardRef as ReactComponent };